import React from 'react';

import { FaQuestion } from 'react-icons/fa';

import useIsMobileScreen from '../../hooks/useCheckIsMobile';
import Button from '../Button';
import PopoverButton from '../PopoverButton';
import './styles.scoped.css';

const SubHeader = ({ text, buttons, popoverTitle }) => {
  const isMobile = useIsMobileScreen();
  return (
    <span className={`wrap ${isMobile ? 'mobile' : ''}`}>
      <h1 className={isMobile ? 'mobile' : ''}>{text}</h1>
      <span className="buttons-group">
        {buttons?.map(({ style, icon, text: buttonText, onPress, className, variant = 'primary' }) => (
          <Button
            key={`${buttonText}-${style}-${icon}-${className}-${variant}`}
            style={style}
            icon={icon}
            text={buttonText}
            onPress={onPress}
            className={className}
            variant={variant}
          />
        ))}
        {!!popoverTitle && (
          <PopoverButton
            emailAddress={process.env.REACT_APP_PORTAL_CONTACT_EMAIL}
            icon={<FaQuestion />}
            title={popoverTitle}
            popoverClassName="popover-button"
          />
        )}
      </span>
    </span>
  );
};
export default SubHeader;
